"use client";

var __jsx = React.createElement;
import useMuscleRouter from "@lib/hooks/use-muscle-router";
import React, { createContext, useContext, useState } from "react";
import { useActiveContent } from "./active-content-context";
import MuscleErrorPage from "@modules/flow-independent-pages/error-page/page";
const ErrorPageContext = /*#__PURE__*/createContext(null);
export const ErrorPageProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: errorCode,
    1: setErrorCode
  } = useState("");
  const router = useMuscleRouter();
  const {
    changeActiveContent,
    setActiveContentToDefault
  } = useActiveContent();
  const renderErrorPage = errorProps => {
    changeActiveContent(__jsx(MuscleErrorPage, errorProps));
  };
  const closeErrorPage = () => {
    setActiveContentToDefault('close error page');
    const currentApp = localStorage.getItem("current-app");
    if (errorCode === "no_session_found") {
      router.replace("/");
    } else {
      router.push("/".concat(currentApp !== null && currentApp !== void 0 ? currentApp : ''));
    }
  };
  return __jsx(ErrorPageContext.Provider, {
    value: {
      renderErrorPage,
      closeErrorPage,
      errorCode
    }
  }, children);
};
export const useErrorPage = () => {
  const context = useContext(ErrorPageContext);
  if (context === null) {
    throw new Error("useErrorPage must be used within a ErrorPageProvider");
  }
  return context;
};